import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ToastrModule } from 'ngx-toastr';
import { EffectsModule } from '@ngrx/effects';

import { NotifyEffects } from '@common/utils/notify/notify.effects';
import { RedirectEffects } from '@common/utils/redirect/redirect.effect';
import { NotifyFacade } from '@common/utils/notify/notify.facade';
import { RedirectFacade } from '@common/utils/redirect/redirect.facade';

@NgModule({
    providers: [NotifyFacade, RedirectFacade],
    imports: [CommonModule, ToastrModule.forRoot(), EffectsModule.forFeature([NotifyEffects, RedirectEffects])],
})
export class UtilsModule {}
